import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/exhibitions/betgames-logo.svg'
import _imports_1 from '@/assets/img/exhibitions/ice_london_2024.png'


const _withScopeId = n => (_pushScopeId("data-v-acc3d290"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "logo" })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" 6-8 February, 2024"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ExCeL London ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "together" }, [
    /*#__PURE__*/_createTextVNode("Together with "),
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_7 = { class: "center margin" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Meet as at Vilnius"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FAIcon = _resolveComponent("FAIcon")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FAIcon, {
            icon: "times",
            class: "ico close",
            onClick: _ctx.hideModal
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "ice-logo",
              src: require('@/assets/img/exhibitions/IceLondon.png')
            }, null, 8, _hoisted_4),
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: `https://www.icegaming.com/exhibitor-list?&sortby=customfield_12158%20desc%2Ccustomfield_11984%20desc&searchTerm=aardvark&searchgroup=D48EE8B1-exhibitors`,
                target: "_blank",
                class: "btn"
              }, " Check More ", 8, _hoisted_8)
            ])
          ]),
          _hoisted_9
        ])
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 1
  }))
}